import React from 'react';
import './BookingFunnel.css';
import { formatNumber, calculatePercentage } from '../../../utils/analyticsHelpers';

const FUNNEL_STEPS = [
    {
        key: 'tripViews',
        label: 'Trip Views',
        base: null
    },
    {
        key: 'bookingStarted',
        label: 'Booking Started',
        base: 'tripViews'
    },
    {
        key: 'checkoutStarted',
        label: 'Checkout Started',
        base: 'bookingStarted'
    },
    {
        key: 'paymentInitiated',
        label: 'Payment Initiated',
        base: 'checkoutStarted'
    },
    {
        key: 'paymentSuccess',
        label: 'Payment Success',
        base: 'paymentInitiated'
    },
    {
        key: 'bookingConfirmed',
        label: 'Booking Confirmed',
        base: 'paymentSuccess'
    }
];

const BookingFunnel = ({ tripViews = 0, funnel = {} }) => {
    return (
        <section className='analyticsSection funnelSection'>
            <div className='analyticsSectionHeader'>
                <div>
                    <h2>Booking Funnel</h2>

                    <span>User progression</span>
                </div>
            </div>

            <div className='funnelCompact'>
                {FUNNEL_STEPS.map((step, index) => {
                    const value = step.key === 'tripViews' ? tripViews : funnel[step.key] || 0;

                    const base = step.base
                        ? step.base === 'tripViews'
                            ? tripViews
                            : funnel[step.base] || 0
                        : null;

                    const percentage = base !== null ? calculatePercentage(value, base) : null;

                    return (
                        <React.Fragment key={step.key}>
                            <div className='funnelCompactItem'>
                                <span>{step.label}</span>

                                <strong>{formatNumber(value)}</strong>

                                {percentage !== null && <small>{percentage}%</small>}
                            </div>

                            {index < FUNNEL_STEPS.length - 1 && <div className='funnelCompactArrow'>→</div>}
                        </React.Fragment>
                    );
                })}
            </div>
        </section>
    );
};

export default BookingFunnel;
